import { Action } from "types/actions";
import clamp from "lodash/clamp";

export type TvState = Readonly<{
  muted: boolean;
  volume: number;
  volumeVisible: boolean;
}>;

export const MAX_VOLUME = 100;

export const initialTvState = {
  muted: false,
  volume: MAX_VOLUME,
  volumeVisible: false,
};

export const tvReducer = (state: TvState = initialTvState, action: Action) => {
  switch (action.type) {
    case "CHANGE_VOLUME": {
      const vol = state.volume + action.value;
      return { ...state, volume: clamp(vol, 0, MAX_VOLUME) };
    }
    case "SET_VOLUME": {
      return { ...state, volume: clamp(action.value, 0, MAX_VOLUME) };
    }
    case "MUTE":
      return { ...state, muted: true };

    case "UNMUTE":
      return { ...state, muted: false };

    case "SHOW_VOLUME":
      return { ...state, volumeVisible: true };

    case "HIDE_VOLUME":
      return { ...state, volumeVisible: false };

    default:
      return state;
  }
};
